/* ── Auto-load BOGO discount guard wherever BOGO offers are rendered ── */
(function () {
  if (window.__mmBogoGuardLoaded) return;
  try {
    var s = document.currentScript;
    var base = s && s.src ? s.src.replace(/mm-bogo-offer\.js.*$/, "") : "";
    var g = document.createElement("script");
    g.src = base + "mm-bogo-guard.js";
    g.defer = true;
    document.head.appendChild(g);
  } catch (e) {}
})();

var mmoLang = "en";
var mmoSettings = {};

function mmBogoTimeLeft(endsAt) {
  if (!endsAt) return null;
  var left = new Date(endsAt).getTime() - Date.now();
  if (left <= 0) return mmoLang === "ar" ? "انتهى العرض" : "Offer expired";

  var d = Math.floor(left / 86400000);
  var h = Math.floor((left % 86400000) / 3600000);
  var m = Math.floor((left % 3600000) / 60000);
  var s = Math.floor((left % 60000) / 1000);
  var pad = function (n) { return String(n).padStart(2, "0"); };
  var lbls = mmoSettings || {};

  if (d >= 3) {
    return d + (mmoLang === "ar" ? " " + (lbls.daysAr || "أيام") : " " + (lbls.daysEn || "Days")) + " " + pad(h) + ":" + pad(m) + ":" + pad(s);
  }
  var totalH = d * 24 + h;
  return pad(totalH) + ":" + pad(m) + ":" + pad(s);
}

function mmExtractId(id) {
  if (!id) return null;
  if (typeof id === "number") return id;
  var parts = String(id).split("/");
  var last = parts[parts.length - 1];
  return parseInt(last, 10);
}

function mmCleanOfferSummary(raw, fallback) {
  var text = String(raw || "").trim();
  if (!text) return fallback || "";
  var looksLikeHtml = /<\/?[a-z][\s\S]*>/i.test(text);
  text = text
    .replace(/<style[\s\S]*?<\/style>/gi, " ")
    .replace(/<script[\s\S]*?<\/script>/gi, " ")
    .replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/\s+/g, " ")
    .trim();
  if (!text || looksLikeHtml || text.length > 140) return fallback || "";
  return text;
}

function mmBogoStartTimer(endsAt, el) {
  if (!endsAt || !el) return;
  var endMs = new Date(endsAt).getTime();
  if (isNaN(endMs)) return;

  function tick() {
    var left = endMs - Date.now();
    if (left <= 0) {
      el.textContent = mmoLang === "ar" ? "انتهى العرض" : "Expired";
      return;
    }
    
    var d = Math.floor(left / 864e5), h = Math.floor((left % 864e5) / 36e5);
    var m = Math.floor((left % 36e5) / 6e4), s = Math.floor((left % 6e4) / 1e3);
    var pad = function(n) { return (n < 10 ? "0" : "") + n; };
    
    if (d >= 3) el.textContent = d + (mmoLang === "ar" ? " أيام " : "d ") + pad(h) + ":" + pad(m) + ":" + pad(s);
    else el.textContent = pad(d * 24 + h) + ":" + pad(m) + ":" + pad(s);
    
    setTimeout(tick, 1000);
  }
  tick();
}

/* ── BOGO Offer Block ── */
(async function () {
  function reportReady(didShow) {
    if (window.MMProductOffers) window.MMProductOffers.widgetReady(!!didShow);
    else if (window.mmOfferWidgetReady) window.mmOfferWidgetReady(!!didShow);
  }

  function boot() {
    var containers = document.querySelectorAll('[data-mm-bogo-block]');
    if (!containers.length) {
      reportReady(false);
      return;
    }
    for (var ci = 0; ci < containers.length; ci++) {
    (async function (container) {
      var shown = false;
      function qs(sel) { return container.querySelector(sel); }

      function prodImg(p) {
        if (!p) return '';
        if (typeof p.featured_image === 'string' && p.featured_image) return p.featured_image;
        if (p.featured_image && p.featured_image.src) return p.featured_image.src;
        if (p.images && p.images.length) {
          return typeof p.images[0] === 'string' ? p.images[0] : '';
        }
        return '';
      }

      var shopDomain = (window.Shopify && window.Shopify.shop) || '';
      var currentHandle = container.dataset.productHandle;
      var currentVarId = mmExtractId(container.dataset.variantId);
      // Sync currentVarId with main product page variant changes
      (function syncBogoVariant() {
        function readFromUrl() {
          var p = new URLSearchParams(window.location.search).get("variant");
          if (p) { currentVarId = mmExtractId(p); }
        }
        readFromUrl();
        if (!window.__mmOfferVariantSync) {
          window.__mmOfferVariantSync = true;
          document.addEventListener("change", function (e) {
            if (e.target && (e.target.name === "id" || e.target.dataset.productSelect) && e.target.closest("form[action*='/cart/add']")) {
              document.dispatchEvent(new CustomEvent("mm:offer-variant-sync", { detail: { variantId: mmExtractId(e.target.value) } }));
            }
          });
          document.addEventListener("variant:changed", function (e) {
            if (e.detail && e.detail.variant && e.detail.variant.id) {
              document.dispatchEvent(new CustomEvent("mm:offer-variant-sync", { detail: { variantId: mmExtractId(e.detail.variant.id) } }));
            }
          });
          document.addEventListener("variantChange", function (e) {
            if (e.detail && e.detail.variant && e.detail.variant.id) {
              document.dispatchEvent(new CustomEvent("mm:offer-variant-sync", { detail: { variantId: e.detail.variant.id } }));
            }
          });
          var _push = history.pushState.bind(history);
          history.pushState = function () { _push.apply(history, arguments); document.dispatchEvent(new Event("mm:offer-url-sync")); };
          window.addEventListener("popstate", function () { document.dispatchEvent(new Event("mm:offer-url-sync")); });
        }
        document.addEventListener("mm:offer-variant-sync", function (e) {
          if (e.detail && e.detail.variantId) currentVarId = e.detail.variantId;
        });
        document.addEventListener("mm:offer-url-sync", readFromUrl);
      })();

      try {
        mmoLang = (window.Shopify && window.Shopify.locale) || "en";
        var langEl = container.closest("[data-lang]");
        if (langEl && langEl.getAttribute("data-lang")) {
          mmoLang = langEl.getAttribute("data-lang").toLowerCase().indexOf("ar") === 0 ? "ar" : "en";
        }
        if (mmoLang.indexOf("ar") === 0) mmoLang = "ar";
        if (mmoLang === "ar") container.classList.add("mm-rtl");

        var pf = window.__mmPrefetch;
        var url = window.MMOffers && window.MMOffers.offersApiUrl
          ? window.MMOffers.offersApiUrl({ productHandle: currentHandle })
          : "/apps/mm-app/api/offers?productHandle=" + encodeURIComponent(currentHandle);
        var resFn = pf ? pf.fetchOffers(currentHandle) : fetch(url).then(function(r) { return r.ok ? r.json() : { offers: [], settings: {} }; });
        var data = await resFn;
        if (!data) { return; }
        mmoSettings = data.settings || {};
        try {
          var themeConfig = JSON.parse(mmoSettings.shopifyDealsConfig || "{}");
          if (themeConfig.eidThemeEnabled) container.classList.add("mm-eid-theme");
        } catch(e) {}
        if (!data.offers || !data.offers.length) return;

        var bogoOffer = data.offers.find(function (o) { return o.type === "BOGO"; });
        if (!bogoOffer) return;

        var bogoConfig = {};
        try { bogoConfig = JSON.parse(bogoOffer.bundleItemsConfig || "{}"); } catch (e) { }

        var buyQty = parseInt(bogoOffer.bogoQtyBuy || "2", 10);
        var freeQty = parseInt(bogoOffer.bogoQtyGet || "1", 10);

        try {
          var ds = JSON.parse(bogoOffer.displaySettings || "{}");
          if (ds.bogoQtyBuy) buyQty = parseInt(ds.bogoQtyBuy, 10);
          if (ds.bogoQtyGet) freeQty = parseInt(ds.bogoQtyGet, 10);
        } catch (e) { }

        var fetchProd = async function (h) {
          if (!h) return null;
          if (pf) return pf.fetchProduct(h);
          var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
          if (root.endsWith("/")) root = root.slice(0, -1);
          var r = await fetch(root + "/products/" + h + ".js");
          return r.ok ? r.json() : null;
        };

        var triggerH = (bogoConfig.trigger && bogoConfig.trigger.handle) || (bogoOffer.triggerProducts && JSON.parse(bogoOffer.triggerProducts)[0]) || currentHandle;
        var targetH = (bogoConfig.target && bogoConfig.target.handle) || (bogoOffer.targetProducts && JSON.parse(bogoOffer.targetProducts)[0]) || triggerH;

        var triggerP = await fetchProd(triggerH);
        // If trigger product not found, hide block and abort
        if (!triggerP) { console.warn("MM BOGO: trigger product not found:", triggerH); return; }

        var targetOptions = (bogoConfig.target && bogoConfig.target.type === "choice_group") ? (bogoConfig.target.options || []) : null;
        var targetProducts = null;
        var selectedTargetConfig = bogoConfig.target;
        if (targetOptions && targetOptions.length) {
          targetProducts = await Promise.all(targetOptions.map(function(option) { return fetchProd(option.handle); }));
          targetProducts = targetProducts.filter(Boolean);
          targetP = targetProducts[0] || triggerP;
          selectedTargetConfig = targetOptions[0] || {};
        } else {
          var targetP = triggerH === targetH ? triggerP : await fetchProd(targetH);
        }
        // If separate target product not found, fall back to trigger product
        if (!targetP) { targetP = triggerP; }

        // Update deal visual
        var buyImgEl = qs('.js-mm-bogo-buy-img');
        var getImgEl = qs('.js-mm-bogo-get-img');
        var buyTitleEl = qs('.js-mm-bogo-buy-title');
        var getTitleEl = qs('.js-mm-bogo-get-title');
        var buyNumEl = qs('.js-mm-bogo-buy-num');
        var getNumEl = qs('.js-mm-bogo-get-num');
        var freeTagEl = qs('.js-mm-bogo-free-tag');
        var buyVariantWrap = qs('.js-mm-bogo-buy-variant');
        var getVariantWrap = qs('.js-mm-bogo-get-variant');

        if (buyImgEl) { buyImgEl.src = prodImg(triggerP); buyImgEl.alt = triggerP.title || ''; }
        if (buyTitleEl) buyTitleEl.textContent = triggerP.title;
        if (getImgEl) { getImgEl.src = prodImg(targetP); getImgEl.alt = targetP.title || ''; }
        if (getTitleEl) getTitleEl.textContent = targetP.title;

        // If choice group product titles are available in Arabic from Shopify JSON
        // triggerP and targetP from fetchProd(/products/handle.js) should already be localized.
        // However, we ensure explicit checks if needed.


        if (buyNumEl) buyNumEl.textContent = buyQty;
        if (getNumEl) getNumEl.textContent = freeQty;
        if (freeTagEl) freeTagEl.textContent = mmoLang === "ar" ? (mmoSettings.freeAr || "مجاناً") : (mmoSettings.freeEn || "FREE");

        function priceSpan(minor) {
          if (window.MMOffers && window.MMOffers.priceSpan) {
            return window.MMOffers.priceSpan(minor, container);
          }
          return String(minor);
        }

        function selectedVariant(prod, wrap) {
          if (!prod || !prod.variants || !prod.variants.length) return null;
          if (wrap) {
            var sel = wrap.querySelector("select.mm-bogo-variant-select, select.mmo-bogo__select");
            if (sel && sel.value) {
              var sid = parseInt(sel.value, 10);
              for (var i = 0; i < prod.variants.length; i++) {
                if (prod.variants[i].id === sid) return prod.variants[i];
              }
            }
            var span = wrap.querySelector("[data-value]");
            if (span && span.dataset.value) {
              var vid = parseInt(span.dataset.value, 10);
              for (var j = 0; j < prod.variants.length; j++) {
                if (prod.variants[j].id === vid) return prod.variants[j];
              }
            }
          }
          return prod.variants[0];
        }

        function updateBogoPricing() {
          var box = qs(".js-mm-bogo-pricebox");
          if (!box) return;
          var buyV = selectedVariant(triggerP, buyVariantWrap);
          var getV = selectedVariant(targetP, getVariantWrap) || buyV;
          var buyP = buyV ? buyV.price : 0;
          var getP = getV ? getV.price : buyP;
          var pay = buyP * buyQty;
          var compare = buyP * buyQty + getP * freeQty;
          var nowEl = qs(".js-mm-bogo-price-now");
          var wasEl = qs(".js-mm-bogo-price-was");
          var saveEl = qs(".js-mm-bogo-save-pill");
          if (!pay) {
            box.hidden = true;
            return;
          }
          if (nowEl) nowEl.innerHTML = priceSpan(pay);
          if (wasEl) wasEl.innerHTML = compare > pay ? priceSpan(compare) : "";
          if (saveEl && compare > pay) {
            var pct = Math.round((1 - pay / compare) * 100);
            saveEl.textContent = (mmoLang === "ar" ? "وفر " : "Save ") + pct + "%";
            saveEl.hidden = false;
          } else if (saveEl) {
            saveEl.hidden = true;
          }
          box.hidden = false;
          if (window.MMOffers && window.MMOffers.hydratePrices) {
            window.MMOffers.hydratePrices(box);
          }
        }

        function buildSelectWrap(filtered, imgEl, prod) {
          var field = document.createElement("div");
          field.className = "mmo-bogo__field";
          var lbl = document.createElement("span");
          lbl.className = "mmo-bogo__field-label";
          lbl.textContent = mmoLang === "ar" ? "اختر النكهة" : "Choose flavor";
          var wrap = document.createElement("div");
          wrap.className = "mmo-bogo__select-wrap";
          var sel = document.createElement("select");
          sel.className = "mmo-bogo__select mm-bogo-variant-select";
          sel.setAttribute("aria-label", lbl.textContent);
          if (mmoLang === "ar") sel.setAttribute("dir", "rtl");
          filtered.forEach(function (v) {
            var opt = document.createElement("option");
            opt.value = v.id;
            opt.textContent = v.title;
            sel.appendChild(opt);
          });
          sel.addEventListener("change", function () {
            var selectedId = parseInt(this.value, 10);
            var v = prod.variants.find(function (vr) { return vr.id === selectedId; });
            if (v && imgEl) {
              var imgUrl = (v.featured_image && v.featured_image.src) || prod.featured_image;
              if (imgUrl) imgEl.src = imgUrl;
            }
            updateBogoPricing();
          });
          wrap.appendChild(sel);
          wrap.insertAdjacentHTML("beforeend",
            '<span class="mmo-bogo__select-chevron" aria-hidden="true"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M6 9l6 6 6-6"/></svg></span>'
          );
          field.appendChild(lbl);
          field.appendChild(wrap);
          return field;
        }

        // Helper to render variants
        var renderVariants = function (prod, config, wrap, productChoices, imgEl) {
          if (!prod || !wrap) return;
          var variants = prod.variants || [];
          var mode = config ? config.variantMode : "all";
          var selectedIds = config ? (config.selectedVariantIds || (config.selectedVariantId ? [config.selectedVariantId] : [])) : [];

          var filtered = variants;
          if (mode === "specific" && selectedIds.length > 0) {
            var idSet = new Set(selectedIds.map(String).map(function (s) {
              return s.indexOf("gid://") === 0 ? s.split("/").pop() : s;
            }));
            filtered = variants.filter(function (v) { return idSet.has(String(v.id)); });
          }

          var choiceSelect = "";
          if (productChoices && productChoices.length > 1) {
            choiceSelect = '<div class="mmo-bogo__field mmo-bogo__field--product">' +
              '<span class="mmo-bogo__field-label">' + (mmoLang === "ar" ? "اختر المنتج" : "Choose product") + '</span>' +
              '<div class="mmo-bogo__select-wrap mmo-bogo__select-wrap--product">' +
              '<select class="mmo-bogo__select mm-bogo-product-choice"' + (mmoLang === "ar" ? ' dir="rtl"' : '') + '>' +
              productChoices.map(function (choice, idx) {
                return '<option value="' + idx + '">' + choice.title + '</option>';
              }).join("") +
              '</select>' +
              '<span class="mmo-bogo__select-chevron" aria-hidden="true"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M6 9l6 6 6-6"/></svg></span>' +
            '</div></div>';
          }

          wrap.innerHTML = choiceSelect;

          if (filtered.length > 1) {
            wrap.appendChild(buildSelectWrap(filtered, imgEl, prod));
          } else if (filtered.length === 1 && variants.length > 1) {
            var span = document.createElement("span");
            span.className = "mmo-bogo__variant-name mm-bogo-variant-name";
            span.textContent = filtered[0].title;
            span.dataset.value = filtered[0].id;
            wrap.appendChild(span);
          }
        };

        renderVariants(triggerP, bogoConfig.trigger, buyVariantWrap, null, buyImgEl);
        renderVariants(targetP, selectedTargetConfig, getVariantWrap, targetProducts, getImgEl);
        updateBogoPricing();

        if (targetProducts && getVariantWrap) {
          getVariantWrap.addEventListener("change", function(e) {
            if (!e.target || !e.target.classList.contains("mm-bogo-product-choice")) return;
            var idx = parseInt(e.target.value, 10) || 0;
            targetP = targetProducts[idx] || targetP;
            selectedTargetConfig = targetOptions[idx] || {};
            if (getImgEl) getImgEl.src = prodImg(targetP);
            if (getTitleEl) getTitleEl.textContent = targetP.title;
            renderVariants(targetP, selectedTargetConfig, getVariantWrap, targetProducts, getImgEl);
            updateBogoPricing();
            var choice = getVariantWrap.querySelector(".mm-bogo-product-choice");
            if (choice) choice.value = String(idx);
          });
        }

        // Header title
        var headerTitle = qs('.js-mm-bogo-header-title');
        var sectionTitle = (mmoLang === "ar" ? bogoOffer.titleAr : bogoOffer.title) || container.dataset.sectionTitle;
        if (headerTitle) headerTitle.textContent = sectionTitle || (mmoLang === "ar" ? "اشتري " : "Buy ") + buyQty + (mmoLang === "ar" ? " واحصل على " : " Get ") + freeQty + (mmoLang === "ar" ? " مجاناً" : " FREE");

        var subEl = qs('.js-mm-bogo-sub');
        if (subEl) {
          var fallbackSub = (mmoLang === "ar"
              ? ("اشترِ " + buyQty + (buyQty === 1 ? " قطعة" : " قطع") + " واحصل على " + freeQty + (freeQty === 1 ? " مجاناً" : " مجاناً"))
              : ("Buy " + buyQty + ", get " + freeQty + " free"));
          var subText = mmCleanOfferSummary(
            mmoLang === "ar" ? bogoOffer.descriptionAr : bogoOffer.description,
            fallbackSub
          );
          var mainTitle = headerTitle ? headerTitle.textContent : "";
          if (subText && subText !== mainTitle && mainTitle.indexOf(subText) < 0 && subText.indexOf(mainTitle) < 0) {
            subEl.textContent = subText;
            subEl.hidden = false;
          } else {
            subEl.textContent = "";
            subEl.hidden = true;
          }
        }

        var atcBtn = qs('.js-mm-bogo-atc');
        if (atcBtn) {
          atcBtn.textContent = mmoLang === "ar" ? (mmoSettings.claimOfferAr || "احصل على العرض") : (mmoSettings.claimOfferEn || "Claim Offer");
        }

        // Timer/Scarcity
        if (bogoOffer.customerQuantity > 0) {
          var scarcityEl = qs('.js-mm-bogo-scarcity');
          if (scarcityEl) {
            var slbl = mmoLang === "ar" ? (mmoSettings.onlyLeftAr || "متبقي {quantity} فقط!") : (mmoSettings.onlyLeftEn || "Only {quantity} left!");
            scarcityEl.textContent = slbl.replace("{quantity}", bogoOffer.customerQuantity);
            scarcityEl.hidden = false;
            scarcityEl.classList.add("mm-meta-visible");
            scarcityEl.style.setProperty("display", "block", "important");
          }
        }
        if (bogoOffer.endsAt) {
          var timerEl = qs('.js-mm-bogo-timer');
          if (timerEl) {
            timerEl.hidden = false;
            timerEl.classList.add("mm-meta-visible");
            timerEl.style.setProperty("display", "inline-flex", "important");
            mmBogoStartTimer(bogoOffer.endsAt, timerEl.querySelector("span"));
          }
        }

        container.hidden = false;
        container.style.setProperty('display', 'block', 'important');
        container.classList.add('mmo-card--ready');
        shown = true;
        if (window.MMProductOffers) window.MMProductOffers.markVisible(container);

        // ── Mobile compact preview (disabled — always open) ──
        if (false && window.innerWidth <= 600) {
          var mOfferTitle = (mmoLang === "ar" ? (bogoOffer.titleAr || bogoOffer.title) : bogoOffer.title) || "BOGO Deal";
          var mImgs = [triggerP, targetP].filter(Boolean).map(function(p) {
            return '<img src="' + (p.featured_image || '') + '" alt="">';
          }).join("");
          var mSubText = mmoLang === "ar" ? ("اشتر " + buyQty + " واحصل " + freeQty + " مجاناً") : ("Buy " + buyQty + " Get " + freeQty + " FREE");

          var mPreview = document.createElement("div");
          mPreview.className = "mm-mobile-preview";
          var hdrStyle = getComputedStyle(container.querySelector(".mm-bogo-header"));
          mPreview.style.background = hdrStyle.background || "var(--mm-accent)";
          mPreview.style.borderRadius = "14px 14px 0 0";
          mPreview.innerHTML =
            '<div class="mm-mobile-preview-imgs">' + mImgs + '</div>' +
            '<div class="mm-mobile-preview-info">' +
              '<div class="mm-mobile-preview-title">' + mOfferTitle + '</div>' +
              '<div class="mm-mobile-preview-sub">' + mSubText + '</div>' +
            '</div>' +
            '<span class="mm-mobile-preview-badge">FREE</span>' +
            '<div class="mm-mobile-preview-arrow"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M6 9l6 6 6-6"/></svg></div>';

          container.insertBefore(mPreview, container.firstChild);
          container.classList.add("mm-mobile-collapsed");

          mPreview.addEventListener("click", function() {
            if (container.classList.contains("mm-mobile-collapsed")) {
              container.classList.remove("mm-mobile-collapsed");
              container.classList.add("mm-mobile-expanded");
            } else {
              container.classList.remove("mm-mobile-expanded");
              container.classList.add("mm-mobile-collapsed");
            }
          });
        }


        // ATC logic
        if (atcBtn) {
          atcBtn.addEventListener("click", async function () {
            this.disabled = true;
            this.textContent = mmoLang === "ar" ? "جاري الإضافة..." : "Adding…";

            try {
              var getSelectedVariantId = function (prod, wrap) {
                if (!prod) return null;
                if (wrap) {
                  var sel = wrap.querySelector("select.mm-bogo-variant-select, select.mmo-bogo__select");
                  if (sel && sel.value) return String(sel.value);
                  var span = wrap.querySelector("[data-value]");
                  if (span && span.dataset.value) return String(span.dataset.value);
                }
                // Fallback: first available variant
                var firstVariant = prod.variants && prod.variants[0];
                return firstVariant ? String(firstVariant.id) : null;
              };

              var triggerVarId = getSelectedVariantId(triggerP, buyVariantWrap);
              var freeVarId = getSelectedVariantId(targetP, getVariantWrap);

              // Ultimate fallback: if free variant not resolved, use trigger
              if (!freeVarId) freeVarId = triggerVarId;
              if (!triggerVarId) throw new Error("No trigger variant resolved");

              var items = [];
              var bundleGroupId = "bg_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9);
              var props = {
                _offerId: bogoOffer.id,
                _offerType: "BOGO",
                _mmNoDiscountCodes: "true",
                _bundleGroupId: bundleGroupId
              };

              items.push({ id: mmExtractId(triggerVarId), quantity: buyQty, properties: props });
              if (String(freeVarId) === String(triggerVarId)) {
                items[0].quantity = buyQty + freeQty;
              } else {
                items.push({ id: mmExtractId(freeVarId), quantity: freeQty, properties: props });
              }

              var cartRes = await fetch("/cart/add.js", {
                method: "POST", headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ items: items }),
              });
              if (!cartRes.ok) throw new Error(await cartRes.text());

              // Flash deals data sync
              var existingDeals = [];
              try {
                var cd = await (await fetch("/cart.js")).json();
                if (cd.attributes && cd.attributes._flash_deals_data) existingDeals = JSON.parse(cd.attributes._flash_deals_data);
              } catch (e) { }

              var bogoDeals = [];
              bogoDeals.push({
                variantId: String(freeVarId),
                isFreeGift: true,
                discountPercent: 100,
                type: "bogo",
                offerId: bogoOffer.id,
                freeQty: freeQty,
                triggerQty: buyQty
              });
              if (String(triggerVarId) !== String(freeVarId)) {
                bogoDeals.push({
                  variantId: String(triggerVarId),
                  isFreeGift: false,
                  type: "bogo_trigger",
                  offerId: bogoOffer.id
                });
              }

              var newIds = new Set(bogoDeals.map(function (d) { return d.variantId; }));
              var merged = (window.MMOffers && window.MMOffers.mergeOfferDeals)
                ? window.MMOffers.mergeOfferDeals(existingDeals, bogoDeals, bogoOffer.id)
                : existingDeals.filter(function (d) { return d.offerId !== bogoOffer.id; }).concat(bogoDeals);

              await fetch("/cart/update.js", {
                method: "POST", headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  attributes: {
                    _flash_deals_data: JSON.stringify(merged),
                    _mm_country: window.MMOffers && window.MMOffers.marketCountry ? window.MMOffers.marketCountry() : "BH",
                    _mm_has_bogo_offer: "true",
                    _mm_block_discount_codes: "true"
                  }
                }),
              });

              this.textContent = mmoLang === "ar" ? "تمت الإضافة!" : "Added!";
              var finalCart = await (await fetch("/cart.js")).json();
              if (window.MMOffers && window.MMOffers.openCartSheet) {
                await window.MMOffers.openCartSheet(finalCart);
              } else if (window.MMCart && window.MMCart.refresh) {
                var refreshed = await window.MMCart.refresh();
                if (window.MMCart.open) window.MMCart.open({ skipRefresh: true, cart: refreshed });
              }
              var btn = this;
              var claimLabel = mmoLang === "ar" ? (mmoSettings.claimOfferAr || "احصل على العرض") : (mmoSettings.claimOfferEn || "Claim Offer");
              setTimeout(function () {
                btn.disabled = false;
                btn.textContent = claimLabel;
              }, 1600);
            } catch (err) {
              this.disabled = false;
              this.textContent = mmoLang === "ar" ? (mmoSettings.claimOfferAr || "احصل على العرض") : (mmoSettings.claimOfferEn || "Claim Offer");
              console.error("MM BOGO ATC:", err);
            }
          });
        }
      } catch (err) {
        console.error("MM BOGO block:", err);
      } finally {
        reportReady(shown);
      }
    })(containers[ci]);
    }
  }

  if (!document.querySelector('[data-mm-offer-landing]')) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  }
  document.addEventListener('mm:offer-widgets-mount', boot);
})();
